export default {
  PRINT_DELIVERY_CHECKLIST: 'PRINT_DELIVERY_CHECKLIST',
  PRINT_CHECKLIST_VO: 'PRINT_CHECKLIST_VO',
  PRINT_DELIVERY_CERTIFICATES: 'PRINT_DELIVERY_CERTIFICATES',
  PRINT_DELIVERY_CHECKLIST_SALE: 'PRINT_DELIVERY_CHECKLIST_SALE'
}
